import React from "react";
import { Row, Col } from "react-flexbox-grid";
import ModelViewerComponent from "../ui-components/arSliderViewer/ModelViewerComponent";
import "./portfolio.scss";

import DemoImage from "../../assets/portfolio/project03/Guard-500g.png"
import DemoModel from "../../assets/hero/500g.glb";

import demoApto from "../../assets/ar/Apartment.gltf";
import demoAptoImage from "../../assets/ar/predio-preview.png";

class ARPortfolio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      models: [
        {
          id: "1",
          modelSrc: DemoModel,
          coverImage: DemoImage,
          title: "Modelo 1",
        },
        {
            id: "2",
            modelSrc: demoApto,
            coverImage: demoAptoImage,
            title: "Modelo 2",
        },
      ],
    };
  }

  render() {
    return (
      <div id="ar-portfolio">
        <div className="wrapper" style={{ margin: "unset", padding: "unset" }}>
          <ModelViewerComponent models={this.state.models} />
        </div>
      </div>
    );
  }
}

export default ARPortfolio;